import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import IntroPage from './components/pages/IntroPage';
import StudentBenefitPage from './components/pages/StudentBenefitPage';
import PromotionPartnerPage from './components/pages/PromotionPartnerPage';
import StorePromotionPage from './components/pages/StorePromotionPage';
import DownloadPage from './components/pages/DownloadPage';
import PrivacyPage from './components/pages/PrivacyPage';
import TermsPage from './components/pages/TermsPage';
import WebNotFoundPage from './components/pages/WebNotFoundPage';

const WebRoutes = () => {
    return (
        <BrowserRouter>
            <Routes>
                {/* 메인 페이지들 */}
                <Route path="/" element={<IntroPage />} />
                <Route path="/student-benefit" element={<StudentBenefitPage />} />
                <Route path="/promotion-partner" element={<PromotionPartnerPage />} />
                <Route path="/store-promotion" element={<StorePromotionPage />} />
                <Route path="/download" element={<DownloadPage />} />

                {/* 약관 페이지들 */}
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />

                {/* 404 페이지 */}
                <Route path="*" element={<WebNotFoundPage />} />
            </Routes>
        </BrowserRouter>
    );
};

export default WebRoutes;
